export const SITE_MENU = [
  {title: "Все соревнования",
    link: "/allRaces"},
  {title: "Все участники",
    link: "/allRunners"},
  {title: "О нас",
    link: "/about"},
];
